// The dev-only identity switcher — single source of truth for its wire names.
//
// In dev, a web client may "act as" another user by sending this header; every
// backend (legacy server, mission-service, c2-service) resolves req.user from
// it. It is DEV-ONLY: under PROD_AUTH the gateway strips it from every proxied
// request before it reaches a service, and services never advertise it in their
// CORS Allow-Headers. The header name was previously hardcoded as a string
// literal in ~8 independent places (both apiClients, the two service auth
// resolvers, the gateway strip hooks, and every CORS list); this module makes
// it one constant so the name can't drift across them.
//
// HTTP header names are case-insensitive on the wire (Express `req.get`, Node
// `removeHeader`, and browser CORS matching all normalize case), so the exact
// casing here is cosmetic — but keeping ONE spelling keeps greps and logs sane.
export const ACTING_USER_HEADER = 'X-User-Id';

// localStorage key the web clients persist the selected acting-user id under.
// Paired with the header: the client reads this key and sends its value as
// ACTING_USER_HEADER on each request.
export const ACTING_USER_STORAGE_KEY = 'twin-acting-user';

// The ACTIVE-CUSTOMER switcher (multi-customer membership). A user who belongs to
// more than one customer operates in ONE active customer at a time; this header
// carries the selected customer id, and the backend re-scopes the request's role
// + visibility to it (a member may only act in a customer they belong to — the
// server fails closed otherwise). Like ACTING_USER_HEADER it is dev-facing: under
// PROD_AUTH the gateway strips it and the active customer is taken from the
// server-side session instead, never trusted from the client.
export const ACTING_CUSTOMER_HEADER = 'X-Customer-Id';

// localStorage key the web clients persist the selected active customer under.
export const ACTING_CUSTOMER_STORAGE_KEY = 'twin-active-customer';
